"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { EmailPromoModalBlock } from "@/components/custom/EmailPromoModal/EmailPromoModalBlock";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { useExitIntent } from "@/hooks/useExitIntent";
import type { DismissMethod } from "@/lib/analytics/segment";
import { markPromoDismissed } from "@/lib/emailPromoSuppression";
import type { PromoModal } from "@/lib/promoModal/types";
import { parseTrigger } from "@/types/contentful/emailPromoModalTrigger";
import { showModal, trackDismissal } from "./emailPromoModalVisibility";
export interface Props {
  modal: PromoModal;
  onShow?: () => void; // Called once the modal opens, so the page can lock in this campaign.
  isPreview?: boolean; // Contentful draft mode, session guard and trigger still apply.
}
export function EmailPromoModalClient(t0) {
  const $ = _c(40);
  const {
    modal,
    onShow,
    isPreview: t1
  } = t0;
  const isPreview = t1 === undefined ? false : t1;
  const [shownAt, setShownAt] = useState(null);
  const dismissMethodRef = useRef("button");
  let t2;
  if ($[0] !== modal) {
    t2 = parseTrigger(modal);
    $[0] = modal;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const parsed = t2;
  const delayMs = parsed.kind === "delay" ? parsed.delayMs : null;
  const triggerType = parsed.label;
  let t3;
  let t4;
  if ($[2] !== delayMs || $[3] !== isPreview || $[4] !== modal || $[5] !== onShow || $[6] !== triggerType) {
    t3 = () => {
      if (delayMs === null) {
        return;
      }
      const timer = setTimeout(() => showModal({
        modal,
        triggerType,
        isPreview,
        setShownAt,
        onShow
      }), delayMs);
      return () => clearTimeout(timer);
    };
    t4 = [delayMs, modal, isPreview, onShow, triggerType];
    $[2] = delayMs;
    $[3] = isPreview;
    $[4] = modal;
    $[5] = onShow;
    $[6] = triggerType;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== isPreview || $[10] !== modal || $[11] !== onShow || $[12] !== triggerType) {
    t5 = () => showModal({
      modal,
      triggerType,
      isPreview,
      setShownAt,
      onShow
    });
    $[9] = isPreview;
    $[10] = modal;
    $[11] = onShow;
    $[12] = triggerType;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  useExitIntent(t5, parsed.kind === "exit");
  let t6;
  if ($[14] !== isPreview || $[15] !== modal.id) {
    t6 = function closePromoModal() {
      setShownAt(null);
      if (isPreview) {
        return;
      }
      markPromoDismissed(modal.id);
    };
    $[14] = isPreview;
    $[15] = modal.id;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const closePromoModal = t6;
  let t7;
  if ($[17] !== closePromoModal || $[18] !== modal.id || $[19] !== shownAt) {
    t7 = function handleOpenChange(next) {
      if (next) {
        return;
      }
      trackDismissal({
        popupId: modal.id,
        shownAt,
        dismissMethod: dismissMethodRef.current
      });
      closePromoModal();
    };
    $[17] = closePromoModal;
    $[18] = modal.id;
    $[19] = shownAt;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const handleOpenChange = t7;
  let t8;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = function handlePointerDownOutside(event) {
      const pointerEvent = event.detail.originalEvent;
      if (pointerEvent.button === 0 && !pointerEvent.ctrlKey) {
        dismissMethodRef.current = "scrim";
      }
    };
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const handlePointerDownOutside = t8;
  const t9 = shownAt !== null;
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      dismissMethodRef.current = "escape";
    };
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <DialogTitle className="sr-only">Promotional Modal</DialogTitle>;
    t12 = <DialogDescription className="sr-only">Promotional message from StickerGiant.</DialogDescription>;
    $[23] = t11;
    $[24] = t12;
  } else {
    t11 = $[23];
    t12 = $[24];
  }
  let t13;
  if ($[25] !== closePromoModal || $[26] !== modal.blocks || $[27] !== modal.id || $[28] !== shownAt) {
    let t14;
    if ($[30] !== closePromoModal || $[31] !== modal.id || $[32] !== shownAt) {
      t14 = block => <EmailPromoModalBlock key={block.sys.id} block={block} onCtaClick={closePromoModal} popupId={modal.id} shownAt={shownAt ?? undefined} />;
      $[30] = closePromoModal;
      $[31] = modal.id;
      $[32] = shownAt;
      $[33] = t14;
    } else {
      t14 = $[33];
    }
    t13 = modal.blocks.map(t14);
    $[25] = closePromoModal;
    $[26] = modal.blocks;
    $[27] = modal.id;
    $[28] = shownAt;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[34] !== t13) {
    t14 = <DialogContent className="max-h-[90dvh] w-105 gap-6 overflow-hidden border-0 data-[state=closed]:duration-0" overlayClassName="data-[state=closed]:duration-0" onEscapeKeyDown={t10} onPointerDownOutside={handlePointerDownOutside}>{t11}{t12}<div className="flex min-h-0 flex-col gap-6 overflow-y-auto pt-2.5">{t13}</div></DialogContent>;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== handleOpenChange || $[37] !== t14 || $[38] !== t9) {
    t15 = <Dialog open={t9} onOpenChange={handleOpenChange}>{t14}</Dialog>;
    $[36] = handleOpenChange;
    $[37] = t14;
    $[38] = t9;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  return t15;
}